import apiBase from './apiBase';

export default class Api {
  static async getDayLocations(schoolLocationId) {
    return await apiBase.get('/api/school_entry/day_locations/', {
      school_location_id: schoolLocationId,
      new_registration: true,
    });
  }

  static async getCourses(dayLocationId) {
    return await apiBase.get('/api/school_entry/courses/', {
      day_location_id: dayLocationId,
      new_registration: true,
    });
  }

  static async getPrices(dayLocationId, studentId, couponCode, continued) {
    const params = {
      day_location_id: dayLocationId,
      continued,
    };
    if (studentId !== null) {
      params.student_id = studentId;
    }
    if (couponCode !== undefined) {
      params.coupon_used = couponCode;
    }
    return await apiBase.get('/api/school_entry/prices/', params);
  }

  static async getPcTypes(courseId) {
    return await apiBase.get('/api/school_entry/pc_types', {
      course_id: courseId,
    });
  }

  static async setPcType(schoolApplicationId, pcTypeId) {
    return await apiBase.put('/api/mypage_api/pc_type/', {
      school_application_id: schoolApplicationId,
      pc_type_id: pcTypeId,
    });
  }
}
